import { useEffect, useMemo, useRef, useState } from "react"
import { Switch, Button, DatePicker, DatePickerProps, Flex, Form, Input, Table, notification, TableProps, Tooltip, Modal } from "antd"
import TextArea from "antd/es/input/TextArea";
import dayjs, { Dayjs } from "dayjs";
import { useNavigate, useParams } from "react-router-dom";
import { benefit, item, objective } from "../models/Detail";
import { ActivityInterface } from "../models/IActivity";
import JoditReact from "jodit-react";
import 'react-quill/dist/quill.snow.css'; // Quill styles
import {isDateSelected, monthcolumn, showmonth, showyear } from "./functionLater";
import "react-quill/dist/quill.snow.css";
import CkEditor from "./ckeditor/ckEditor";
import { Editor } from '@ckeditor/ckeditor5-core'; // Import Editor type

import axios from "axios";
import moment from "moment";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";



const { RangePicker } = DatePicker;
export function BudgetReqDetail(){
    
    const [form] = Form.useForm();
    const [subform] = Form.useForm();
    const [item] = Form.useForm();
    const [objectiveForm] = Form.useForm();

    const [showItem,setShowItem] = useState(false)
    const [editingRowKey, setEditingRowKey] = useState(0);

    const [important,setimportant] = useState("")
    const [objective,setobjective] = useState("")
    const [benefit,setBenefit] = useState("")
    const [literature,setLiterature] = useState("")
    const [idea,setIdea] = useState("")
    const [reseacherway,setResearchWay] = useState("")

    const [editingKey, setEditingKey] = useState<number | null>(null);
    const [expandedRowKeys, setExpandedRowKeys] = useState<React.Key[]>([]);
    
    // const [tmpBenefit,setBenefit] = useState<benefit[]>([{index:0,benefit:``}]);

    const [tmpItem,settmpItem] = useState<item[]>([])
    const [possesTmpItem,setpossesTmpItem] = useState<item[]>([])
    const [activity,setActivity] = useState<ActivityInterface[]>([])
    

    const [Period, setPeriod] = useState<[string | null, string | null]>([null, null]);

    const [selectedRange, setSelectedRange] = useState<[dayjs.Dayjs | null, dayjs.Dayjs | null]>([null, null]);
    const [editselectedRange, setEditSelectedRange] = useState<[dayjs.Dayjs | null, dayjs.Dayjs | null]>([null, null]);
    const [selectedyear,setSelectedYear] = useState(9999)
    const [selectedmonth,SetSelectedmonth] = useState(999)
    const [endmonth,SetEndedMonth] = useState(999)
    const [TmpDate,settmpDate] = useState<[string | null, string | null]>([null, null]);
    
    const [percentleft,setPercentLeft] = useState(100)

    const [tmpselectedmonth,setTmpselectedmonth] = useState('')
    const [tmpselectedmonth2,setTmpselectedmonth2] = useState('')
    const { project_id } = useParams();

    const [content, setContent] = useState<string>("");

    const importantRef = useRef<Editor | null>(null);
    const objectiveRef = useRef<Editor | null>(null);
    const benefitRef = useRef<Editor | null>(null);
    const literatureRef = useRef<Editor | null>(null);
    const IdeaRef = useRef<Editor | null>(null);
    const ResearchRef = useRef<Editor | null>(null);
    
    const [open,setopen] = useState(false)

    

    const navigate = useNavigate();
    const { CKEditors, getHTML } = CkEditor();


    const handleShowItem = ()=> {
      settmpItem([])
      setpossesTmpItem([])
      setShowItem(!showItem)
        
    }
    const handleCancel = ()=>{
      setopen(false)
    }

    const handleNeededItemDel = async (index: number) => {
      try {
        // Validate and get the current form data
        const formData = await item.validateFields();
    
        // Filter out the item by index
        const updated = formData.needed_item.filter((_: any, idx: number) => idx !== index);
    
        // Re-index the remaining rows
        const reIndexedItems = updated.map((dataitem: any, idx: number) => ({
          ...dataitem,
          index: idx, // Ensure each item has the correct index
        }));
    
    
        // Update the form field with the re-indexed items
        item.setFieldsValue({
          needed_item: updated,
        });
    
        // Update the state if necessary (if you're maintaining a separate state for `needed_item`)
        settmpItem(reIndexedItems);
    
      } catch (error) {
        console.error("Error updating needed_item:", error);
      }
    };
    
    const handlePosssesItemDel = async (index: number) => {
      try {
        // Validate and get the current form data
        const formData = await item.validateFields();
    
        // Filter out the item by index
        const updated = formData.posses_item.filter((_: any, idx: number) => idx !== index);
    
        // Re-index the remaining rows
        const reIndexedItems = updated.map((dataitem: any, idx: number) => ({
          ...dataitem,
          index: idx, // Ensure each item has the correct index
        }));
    
    
        // Update the form field with the re-indexed items
        item.setFieldsValue({
          posses_item: updated,
        });
    
        // Update the state if necessary (if you're maintaining a separate state for `needed_item`)
        setpossesTmpItem(reIndexedItems);
      } catch (error) {
        console.error("Error updating needed_item:", error);
      }
    };
    

    const handleClickItem = () => {
        const tmpindex = tmpItem.length
        const newItem = [...tmpItem]
        newItem.push({index:tmpindex,item:``})
        settmpItem(newItem)
    }

    const handleClickPossesesItem = () => {
        const tmpindex = possesTmpItem.length
        const newItem = [...possesTmpItem]
        newItem.push({index:tmpindex,item:``})
        setpossesTmpItem(newItem)
    }

    const ActivityplanHandle = (value: any) => {
        let tmpact: ActivityInterface[] = [...activity]; // Make sure activity is typed as ActivityInterface[]
        
        const data: ActivityInterface = {
            ActivityId: activity.length, 
            ActivityName: value.ActivityName, 
            Activitydate: [tmpselectedmonth, tmpselectedmonth2], 
            ActivityRatio: Number(value.ActivityRatio), 
        };
        console.log(activity)
    
        // Add the new activity to the list
        tmpact.push(data);
    
        // Calculate the total ActivityRatio
        const sum: number = tmpact.reduce((accumulator, current) => {
            return accumulator + Number(current.ActivityRatio); // Ensure ActivityRatio is a number
        }, 0);
        console.log(Number(sum))
        try {
            if (sum <= 100) {
                setActivity(tmpact);
                setPercentLeft(100-sum)
                form.resetFields(); // Reset the form if using a form instance
            } else {
                throw new TypeError("จำนวนรวมร้อยละในโครงการของท่านมีค่ารวมเกิน 100");
            }
        } catch (error) {
            if (error instanceof Error) {
              // Handle error with a notification using the error message
              notification.error({
                message: "พบข้อผิดพลาด",  // General error heading
                description: error.message,  // Use the thrown error message
              });
            } else {
              // Handle non-Error type (just in case)
              notification.error({
                message: "พบข้อผิดพลาด",
                description: "เกิดข้อผิดพลาดบางอย่าง",
              });
            }
          }
    };

   
    
    const expandedRowRender = (record: { ActivityId: number; ActivityName: string; ActivityRatio: number; Activitydate: moment.MomentInput[]; }) => {
        return (
          <Form
            form={subform}
            onFinish={(values) => {
              // Extract the new ActivityName, ActivityRatio, and selected date range from the form values
              const { ActivityName, ActivityRatio } = values;
              
              // Create a new ActivityInterface object based on the current form values
              const updatedActivity: ActivityInterface = {
                ActivityId: record.ActivityId, // Keep the ActivityId the same
                ActivityName, // New ActivityName from the form
                ActivityRatio: Number(ActivityRatio), // Convert ActivityRatio to number
                Activitydate: TmpDate // Use the updated TmpDate for the new date range
              };
    
              // Update the activity list by mapping over the activities and replacing the updated item
              const newActivityList = activity.map((item) =>
                item.ActivityId === record.ActivityId ? updatedActivity : item
              );
    
              // Calculate the total ActivityRatio
              const sum = newActivityList.reduce((acc, curr) => acc + Number(curr.ActivityRatio), 0);
    
              try {
                // Ensure the total ratio does not exceed 100
                if (sum <= 100) {
                  setActivity(newActivityList); // Update the state with the new list
                  setPercentLeft(100 - sum); // Update the remaining percentage
                  onCancelEdit(); // Close the editing row
                } else {
                  throw new TypeError("จำนวนรวมร้อยละในโครงการของท่านมีค่ารวมเกิน 100");
                }
              } catch (error) {
                notification.error({
                  message: "พบข้อผิดพลาด",
                  description:
                    "จำนวนรวมร้อยละในโครงการของท่านมีค่ารวมเกิน 100 โปรดแก้ไขและตรวจสอบค่าร้อยละในโครงการของท่านก่อนจะเพิ่มโครงการใหม่",
                });
              }
            }}
           
          >
            <Form.Item label="กิจกรรมในการทำงานวิจัย" name="ActivityName">
              <TextArea style={{width:600}} autoSize/>
            </Form.Item>
    
            <Form.Item label="ระยะเวลาที่ทำกิจกรรม" name="Activitydate">
                <RangePicker
                picker="month"
                onChange={(value, dateString) => {
                let tmp = dateString[0]?.split("-") || [];
                let tmp1 = dateString[1]?.split("-") || [];

                if (tmp.length > 1 && tmp1.length > 1) {
                    settmpDate(dateString); // Update the selected period
                }
                }}
                disabledDate={(current) => {
                    // Check if the selected range is set
                    if (selectedRange[0] && selectedRange[1]) {
                      return current < selectedRange[0] || current > selectedRange[1]; // Disable dates outside the selected range
                    }
                    return false; // Enable all dates if no range is selected
                  }}
                value={editselectedRange}
                placeholder={['เดือนที่เริ่มต้นโครงการ', 'เดือนที่สิ้นสุดโครงการ']}
                />
            </Form.Item>
    
            <Form.Item label="ร้อยละของกิจกรรมในโครงการ" name="ActivityRatio">
              <Input type="number" />
            </Form.Item>
    
            <Form.Item>
              <Button type="primary" style={{backgroundColor:'#33b249',color:'white',borderColor:'#33b249'}} htmlType="submit">
                บันทึก
              </Button>
              <Button style={{ marginLeft: "10px" }} onClick={onCancelEdit}>
                ยกเลิก
              </Button>
            </Form.Item>
          </Form>
        );
    };
    
    const submit = async () => {
      const formData = await item.validateFields();

      const mergedDataItem = tmpItem.map((Topic: any, index: number) => ({
        index,
        item:formData.needed_item[index],
      }));

      const mergedDataPossesItem = possesTmpItem.map((Topic: any, index: number) => ({
        index,
        item:formData.posses_item[index],
      }));

      const data ={
        part:'part3',
        important:important,
        objective: objective,
        benefit: benefit,
        literature:literature,
        idea:idea,
        solution:reseacherway,
        duration: (Period[0] === null && Period[1] === null) ? null : JSON.stringify(Period),
        activity: JSON.stringify(activity),
        item:JSON.stringify(mergedDataItem),
        possesTmpItem:JSON.stringify(mergedDataPossesItem)
      }
      console.log (data)

      try{
            
        axios.patch(`${process.env.REACT_APP_BASE}/UpdateBudgetReq/${project_id}`,data)
        .then((response)=>{
            if (response.status === 200) {
                console.log("บันทึกสำเร็จ")
                console.log(response);
                notification.success({
                  message: "บันทึกข้อมูลสำเร็จ",
                })
              }
        }).catch((error)=>{
            console.log(error)
            console.log(error.response)
            notification.error({
                message: "บันทึกข้อมูลไม่สำเร็จ",
                description: error.response
            });
        })
    }catch{
        notification.error({
            message: "บันทึกข้อมูลไม่สำเร็จ",
            description: "มีค่าว่างอยู่ในข้อมูลของคุณ",
        })
    }

    } 

    const handleMainInfo = async () =>{
      const formData = await item.validateFields();
      console.log(tmpItem)
      console.log(possesTmpItem)
      
      console.log(item.validateFields())
      const mergedDataItem = tmpItem.map((Topic: any, index: number) => ({
        index,
        item:formData.needed_item[index],
      }));

      const mergedDataPossesItem = possesTmpItem.map((Topic: any, index: number) => ({
        index,
        item:formData.posses_item[index],
      }));

      const data ={
        part:'part3',
        important:important,
        objective: objective,
        benefit: benefit,
        literature:literature,
        idea:idea,
        solution:reseacherway,
        duration: (Period[0] === null && Period[1] === null) ? null : JSON.stringify(Period),
        activity: JSON.stringify(activity),
        item:JSON.stringify(mergedDataItem),
        possesTmpItem:JSON.stringify(mergedDataPossesItem)
      }
        console.log(data)
        try{
            
            axios.patch(`${process.env.REACT_APP_BASE}/UpdateBudgetReq/${project_id}`,data)
            .then((response)=>{
                if (response.status === 200) {
                    console.log("บันทึกสำเร็จ")
                    console.log(response);
                    navigate(`/VRIIS/BudgetReqInfo/${project_id}`)
                  }
            }).catch((error)=>{
                console.log(error)
                console.log(error.response)
                notification.error({
                    message: "บันทึกข้อมูลไม่สำเร็จ",
                    description: error.response
                });
            })
        }catch{
            notification.error({
                message: "บันทึกข้อมูลไม่สำเร็จ",
                description: "มีค่าว่างอยู่ในข้อมูลของคุณ",
            })
        }
        
        

        
    }
    const handlenextpart = async () =>{
        try{
            const formData = await item.validateFields();

            const mergedDataItem = tmpItem.map((Topic: any, index: number) => ({
              index,
              item:formData.needed_item[index],
            }));
      
            const mergedDataPossesItem = possesTmpItem.map((Topic: any, index: number) => ({
              index,
              item:formData.posses_item[index],
            }));
      
            const data ={
              part:'part3',
              important:important,
              objective: objective,
              benefit: benefit,
              literature:literature,
              idea:idea,
              solution:reseacherway,
              duration: (Period[0] === null && Period[1] === null) ? null : JSON.stringify(Period),
              activity: JSON.stringify(activity),
              item:JSON.stringify(mergedDataItem),
              possesTmpItem:JSON.stringify(mergedDataPossesItem)
            }
                console.log(data)
                axios.patch(`${process.env.REACT_APP_BASE}/UpdateBudgetReq/${project_id}`,data)
                .then((response)=>{
                    if (response.status === 200) {
                        console.log("บันทึกสำเร็จ")
                        console.log(response);
                        navigate(`/VRIIS/BudgetReqResult/${project_id}`)
                    }
                }).catch((error)=>{
                    console.log(error)
                    notification.error({
                        message: "บันทึกข้อมูลไม่สำเร็จ",
                    });
                })
            
        }catch{
            notification.error({
                message: "บันทึกข้อมูลไม่สำเร็จ",
                description: "มีค่าว่างอยู่ในข้อมูลของคุณ",
            })  
        }
    }
      const getYearMonth = (date: Dayjs) => date.year() * 12 + date.month();
      // Disabled 12 months from the selected date
const disabled12MonthsDate: DatePickerProps['disabledDate'] = (current, { from, type }) => {
    if (from) {
      const minDate = from.add(-11, 'months');
      const maxDate = from.add(11, 'months');
  
      switch (type) {
        case 'year':
          return current.year() < minDate.year() || current.year() > maxDate.year();
  
        default:
          return (
            getYearMonth(current) < getYearMonth(minDate) ||
            getYearMonth(current) > getYearMonth(maxDate)
          );
      }
    }
  
    return false;
  };
  const onEditClick = (record : any) => {
    setEditingKey(record.ActivityId); // Set the editing key
    
    subform.setFieldsValue({
      ActivityName: record.ActivityName,
      ActivityRatio: record.ActivityRatio,
      Activitydate: [dayjs(record.Activitydate[0]), dayjs(record.Activitydate[1])],
    });
    settmpDate(record.Activitydate)
    // Expand the row
    setExpandedRowKeys([record.ActivityId]); // Only expand the row being edited
  };
  const onCancelEdit = () => {
    setEditingKey(null); // Reset editing key
    setExpandedRowKeys([]); // Collapse all expanded rows
  };

  const config = useMemo(() => ({
    readonly: false,
    minHeight: 400,
    maxHeight: 1500,
    inline: false,
    autoResize: true,
    disableDragAndDrop: false,
    placeholder:'',
    resizer: {
      forImageChangeAttributes: true, // Enable image resizing attributes
    },

    uploader: {
        insertImageAsBase64URI: true, // Ensure images are uploaded, not embedded as Base64
      },
    table: {
      allowCellSelection: true,
      allowResizeColumn: true,
      allowResizeRow: true,
      useExtraClasses: true,
      selectionCellStyle: {
        backgroundColor: '#a8d8eb', // Style for selected table cells
      },
    },
    showXPathInStatusbar: false,
    image: {
      allowResizeX: true, // Allow horizontal image resizing
      allowResizeY: true, // Allow vertical image resizing
      forImageChangeAttributes: true
    },
    style: {
        allowStyle: true // Ensure inline styles like text alignment are allowed
      },
    poweredByJodit:false
  }), []);
    
    const getData = async() =>{
        axios.get(`${process.env.REACT_APP_BASE}/BudgetReqInfo/${project_id}/${sessionStorage.getItem('user')}`).then(response=>{
        console.log(response.data.main)
          if(response.data.main[0].benefit){
          setBenefit(response.data.main[0].benefit)
        }
        if(response.data.main[0].resolution){
          setimportant(response.data.main[0].resolution)
        }
        if(response.data.main[0].objective_list){
          setobjective (response.data.main[0].objective_list)
        }
        if(response.data.main[0].needed_item?.length>0||response.data.main[0].possesed_item?.length>0){
          setShowItem(true)
          console.log(response.data.main[0].needed_item)
          if(response.data.main[0].needed_item)
            {settmpItem(JSON.parse(response.data.main[0].needed_item))}
          if(response.data.main[0].possesed_item){
            {setpossesTmpItem(JSON.parse(response.data.main[0].possesed_item))}
          }
        }
        if(response.data.main[0].literacy){
          setLiterature(response.data.main[0].literacy)
        }
        if(response.data.main[0].idea){
          setIdea(response.data.main[0].idea)
        }
        if(response.data.main[0].solution){
          setResearchWay(response.data.main[0].solution)
        }
        if(response.data.main[0].period){
          const jsondata = JSON.parse(response.data.main[0].period)
          const parsedStartDate = dayjs(jsondata[0], 'YYYY-MM');
          const parsedEndDate = dayjs(jsondata[1], 'YYYY-MM');
          const startmonth = parsedStartDate.format('YYYY-MM')
          const start = startmonth.split('-')
          const datamonth2 = jsondata[1].split('-')
          SetEndedMonth(Number(datamonth2[1]))
          console.log(parsedStartDate)
          setSelectedRange([parsedStartDate, parsedEndDate]);
          setPeriod(jsondata)
          SetSelectedmonth(Number(start[1]))
          setSelectedYear(Number(start[0]))
        }
        if(response.data.main[0].activity){
          setActivity(JSON.parse(response.data.main[0].activity))
        }
        
        
          if(response.data.main[0].benefit
            &&response.data.main[0].resolution
            &&response.data.main[0].objective_list
            &&response.data.main[0].needed_item
            &&response.data.main[0].possesed_item
            &&response.data.main[0].literacy
            &&response.data.main[0].idea
            &&response.data.main[0].solution
            &&response.data.main[0].period
            &&response.data.main[0].activity
        ){  const jsondata = JSON.parse(response.data.main[0].period)
            const parsedStartDate = dayjs(jsondata[0], 'YYYY-MM');
            const parsedEndDate = dayjs(jsondata[1], 'YYYY-MM');
            const startmonth = parsedStartDate.format('YYYY-MM')
            const start = startmonth.split('-')
            const datamonth2 = jsondata[1].split('-')
            SetEndedMonth(Number(datamonth2[1]))
            console.log(parsedStartDate)
            setSelectedRange([parsedStartDate, parsedEndDate]);
            setPeriod(jsondata)
            SetSelectedmonth(Number(start[1]))
            setSelectedYear(Number(start[0]))
            


            console.log(response.data)
            setimportant(response.data.main[0].resolution)
            setobjective(response.data.main[0].objective_list)
            setBenefit(response.data.main[0].benefit)
            setLiterature(response.data.main[0].literacy)
            setIdea(response.data.main[0].idea)
            setResearchWay(response.data.main[0].solution)
            setActivity(JSON.parse(response.data.main[0].activity))
            

            const sum: number = JSON.parse(response.data.main[0].activity).reduce((accumulator: any, current: { ActivityRatio: any; }) => {
                return accumulator + current.ActivityRatio; // Ensure ActivityRatio is a number
            }, 0);
            setPercentLeft(percentleft-sum)
            
        }})}


    

      useEffect(()=>{
        getData();
    },[]);
    const handleEditorChange = () =>{
        setimportant(getHTML(importantRef))
    }
    const handleobjectiveEditorChange = () =>{
      setobjective(getHTML(objectiveRef))
  }
  const handlebenefitEditorChange = () =>{
    setBenefit(getHTML(benefitRef))
}

    const handleLiteratureEditorChange = () =>{
        setLiterature(getHTML(literatureRef))
    }
    const handleIdeaEditorChange = () =>{
        setIdea(getHTML(IdeaRef))
       
    }
    const handleResearchWayChange = () =>{
        setResearchWay(getHTML(ResearchRef))
       
    }
    
    return(
        <div
        style={{
            padding:15
          }}>
            <h1 className="text-3xl font-semibold ">แบบฟอร์มเสนอโครงการงานวิจัยและนวัตกรรม</h1>  
            <p>เพื่อขอรับเงินทุนสนับสนุนงานวิจัยและนวัตกรรมจากมหาวิทยาลัยวงษ์ชวลิตกุล</p>
            <br/>
          <hr/>
          <br/>
          <div id="part-1"></div>
            <h2 className="text-3xl font-bold ">ส่วนที่ 3 รายละเอียดโครงการงานวิจัย</h2>
            
          <hr/>
          <br/>

        <p className="font-semibold">ความสำคัญ / เหตุผล / ปัญหาที่สำคัญของงานวิจัย / นิยาม</p>
        
        <CKEditors
        myRef={importantRef}
        htmlBox={important}
        onBlur={handleEditorChange}
        toolstate={true}
      />
        <div id="part-2"></div>
        <br/>
        <br/>
        <Flex justify='space-between' style={{marginBottom:10}}>
          <p className="font-semibold">วัตถุประสงค์ของงานวิจัย</p>
          
          {/* <Button onClick={handleclick}>เพิ่มข้อมูล</Button> */}
          </Flex>
          <CKEditors
          myRef={objectiveRef}
          htmlBox={objective }
          onBlur={handleobjectiveEditorChange}
          toolstate={true}/>
          
            {/* <Table columns={[
                {
                title: 'ข้อ',
                key: 'index',
                dataIndex: 'index',
                width:120,
                render: (text, record) => <>{record.index+1}</>, // Now rendering the index properly
                },
                {
                title: 'วัตถุประสงค์',
                key: 'objective',
                dataIndex: 'objective',
                render: (text, record) => (
                    <>
                    <TextArea
                        value={record.objective}
                        onChange={(e) => {
                        const updatedObjectives = [...tmpObjective];
                        updatedObjectives[record.index].objective = e.target.value;
                        setTmpObjective(updatedObjectives); // Update state properly
                        }}
                        autoSize
                    />
                    </>
                ),
                },
                {
                    title: '',
                    dataIndex: 'action',
                    width: 150,
                    render: (_, record) => (
                      <><Tooltip title="ลบข้อมูลในตาราง">
                        <Button
                          onClick={() => {
                            // Remove the selected objective
                            const updatedObjectives = tmpObjective
                              .filter((item) => item.index !== record.index) // Remove the selected item
                              .map((item, idx) => ({
                                ...item,
                                index: idx, // Reset the index to keep it sequential
                              }));
                            setTmpObjective(updatedObjectives); // Update state with new sequential indices
                            
                        }}
                          danger
                        >
                          <DeleteOutlined />
                        </Button></Tooltip>
                      </>
                    ),
                  },
                ]} dataSource={tmpObjective}/> */}
        
        <div id="part-3"></div>
        <br/>
        <br/>
        <Flex justify='space-between'>
          <p className="font-semibold">ประโยชน์ที่คาดว่าจะได้รับ</p>
        {/* <Button onClick={handleClickBene}>เพิ่มข้อมูล</Button> */}
        </Flex>
        <CKEditors
        myRef={benefitRef}
        htmlBox={benefit }
        onBlur={handlebenefitEditorChange}
        toolstate={true}
        />
        {/* <Table
            columns={[
                {
                    title: 'ข้อ',
                    key: 'index',
                    dataIndex: 'index',
                    width:120,
                    render: (text, record) => <>{record.index+1}</>, // Now rendering the index properly
                },
                {
                    title: 'ประโยชน์',
                    key: 'benefit',
                    dataIndex: 'benefit',
                    render: (text, record) => (
                        <>
                        <Input
                            value={record.benefit}
                            onChange={(e) => {
                            const updatedBenefit = [...tmpBenefit];
                            updatedBenefit[record.index].benefit = e.target.value;
                            setBenefit(updatedBenefit); // Update state properly
                            }}
                        />
                        </>
                    ),
                },
                {
                    title:'',
                    key:'action',
                    dataIndex:'action',
                    width:150,
                    render : (_, record) =>
                        <><Tooltip title="ลบข้อมูลในตาราง"><Button
                            onClick = {()=>{
                                const updatedBenefit = tmpBenefit
                                .filter((item) => item.index !== record.index)
                                .map((item, idx) => ({
                                    ...item,
                                    index: idx, // Reset the index to keep it sequential
                                  }));
                                  setBenefit(updatedBenefit);
                            }}
                        danger
                        ><DeleteOutlined /></Button></Tooltip></>
                }
        ]} dataSource={tmpBenefit}
        /> */}
        <div id="part-4"></div>
        <br/>
        <br/>
        <p className="font-semibold">การทบทวนวรรณกรรมและผลงานวิจัยที่เกี่ยวข้อง</p>
        <CKEditors
        myRef={literatureRef}
        htmlBox={literature}
        onBlur={handleLiteratureEditorChange}
        toolstate={true}
        />

        <div id="part-5"></div>
        <br/>
        <br/>
        <p className="font-semibold">กรอบแนวคิดในการวิจัย</p>
        <CKEditors
        myRef={IdeaRef}
        htmlBox={idea}
        onBlur={handleIdeaEditorChange}
        toolstate={true}
        />
        <br/>
        <br/>
        
        <p className="font-semibold">ระเบียบวิธีวิจัย (รูปแบบการวิจัย/ตัวแปร/ประชากรและกลุ่มตัวอย่าง/เครื่องมือการวิจัย/ขั้นตอนการวิจัย/สถิติและการวิเคราะห์ข้อมูล)</p>
        <CKEditors
        myRef={ResearchRef}
        htmlBox={reseacherway}
        onBlur={handleResearchWayChange}
        toolstate={true}
        />
        <div id="part-6"></div>
        <br/>
        <br/>
        <p className="font-semibold">ระยะเวลาทำการวิจัย (กรุณากรอกข้อมูลตั้งแต่เวลาที่เริ่มกิจกรรม)</p>
        <Form.Item layout="vertical" >
            <RangePicker 
            onChange={(value, dateString) => {
                console.log('Selected Time: ', value);
                console.log('Formatted Selected Time: ', dateString);
                
                // Extract month from selected dates
                let tmp = dateString[0]?.split("-") || [];
                let tmp1 = dateString[1]?.split("-") || [];

                // Update state with selected values
                if (tmp.length > 1 && tmp1.length > 1) {
                SetEndedMonth(Number(tmp1[1])); // Set the end month
                setSelectedYear(Number(tmp1[0]))
                SetSelectedmonth(Number(tmp[1])); // Set the start month
                setPeriod(dateString); // Set the period
                }

                // Handle setting the selected date range
                if (Array.isArray(value)) {
                setSelectedRange(value as [Dayjs | null, Dayjs | null]);
                } else {
                setSelectedRange([null, null]); // Reset to null if the selection is cleared
                }
            }} picker="month" 
            value={selectedRange}
            // disabledDate={disabled12MonthsDate}
             width={500} 
             placeholder={['เดือนที่เริ่มต้น', 'เดือนที่สิ้นสุด']}/>
        </Form.Item>
        <br/>
        {Period[0] != null && Period[1] != null&&<><p className='text-semibold' style={{marginBottom:20}}>แผนการดำเนินงานตลอดโครงการ (โปรดระบุขั้นตอนการวิจัยโดยละเอียด) ในกรณีที่เป็นโครงการร่วมกันให้ระบุการแบ่งส่วนงานและผู้รับผิดชอบ</p>
        <Form
            labelCol={{ span: 10 }}
            name="dynamic_form_complex"
            style={{ maxWidth: 800 }}
            autoComplete="off"
            form={form}
            onFinish={ActivityplanHandle}
            >
           <Form.Item label="กิจกรรมในการทำงานวิจัย" name='ActivityName' 
            rules={[{ required: true, message: "โปรดกรอกข้อมูลกิจกรรมในการทำงานวิจัย" }]}>   
                <Input/>
            </Form.Item>
                        
            <Form.Item label="ระยะเวลาที่ทำกิจกรรม" name='Activitydate'
            >
                <RangePicker 
                    format="YYYY-MM"
                    value={selectedRange}
                    onChange={(value, dateString) => {
                        console.log('Selected Time: ', value);
                        console.log('Formatted Selected Time: ', dateString);
                        let tmp = dateString[0].split("-")
                        let tmp1 = dateString[1].split("-")
                        setTmpselectedmonth(dateString[0])
                        setTmpselectedmonth2(dateString[1])
                        console.log(Number(tmp[1]))
                    }}
                    disabledDate={(current) => {
                        // Check if the selected range is set
                        if (selectedRange[0] && selectedRange[1]) {
                          return current < selectedRange[0] || current > selectedRange[1]; // Disable dates outside the selected range
                        }
                        return false; // Enable all dates if no range is selected
                      }}
                    picker="month"
                    placeholder={['เดือนที่เริ่มต้น', 'เดือนที่สิ้นสุด']} />
            </Form.Item>

            <Form.Item label="ร้อยละของกิจกรรมในโครงการ" name='ActivityRatio'  
            rules={[{ required: true, message: "โปรดกรอกข้อมูลกิจกรรมในการทำงานวิจัย" }]}>
                <Input type='Number'/>
            </Form.Item>
              <Flex justify="end"><p style={{marginBottom:10}}>ร้อยละคงเหลือของกิจกรรมที่ท่านสามารถกรอกได้คือ {percentleft}</p></Flex>
                <Flex justify="end"><Button type="default" style={{backgroundColor:'#33b249',color:'white'}} htmlType='submit' 
                >
                    + เพิ่มข้อมูล
                </Button></Flex>
                <p style={{color:'red'}}> * หมายเหตุ : ร้อยละของกิจกรรมในโครงการต้องมีจำนวนรวมกันไม่เกิน 100</p>
              </Form>
              <br/>

              <Table 
                columns={[
                    {
                        title: 'กิจกรรมในการวิจัย',
                        dataIndex: 'ActivityName',
                        align: 'center',
                        fixed: 'left',  
                        width: 200,  
                        className: 'fixed-column',
                    },
                    {
                        title: 'ระยะเวลาที่ทำกิจกรรม',
                        align: 'center',
                        children: monthcolumn(selectedmonth, endmonth, Period),
                    },
                    {
                        title: 'ร้อยละของกิจกรรมในโครงการ',
                        dataIndex: 'ActivityRatio',
                        align: 'center',
                        fixed: 'right',  
                        width: 100, 
                        className: 'fixed-column'
                    },
                    {
                        dataIndex: 'action',
                        key: 'action',
                        fixed: 'right',  
                        width: 100, 
                        className: 'fixed-column',
                        render: (_, record) => (
                            <Flex justify='center'>
                              <Tooltip title="แก้ไขข้อมูลในตาราง">
                                <Button
                                    onClick={() => {
                            onEditClick(record)
                            setEditingRowKey(record.ActivityId);
                            setExpandedRowKeys([record.ActivityId]); // Open row when editing
                        }}
                    >
                        <EditOutlined />
                    </Button></Tooltip>
                    <br />
                    <Tooltip title="ลบข้อมูลในตาราง">
                    <Button 
                        onClick={() => {
                            const updatedActivity = activity.filter((item) => item.ActivityName !== record.ActivityName);
                            setActivity(updatedActivity);
                            const sum = updatedActivity.reduce((accumulator, current) => {
                                return accumulator + Number(current.ActivityRatio);
                            }, 0);
                            setPercentLeft(100 - sum);
                        }}
                        danger
                    >
                        <DeleteOutlined />
                    </Button></Tooltip>
                </Flex>
                        ),
                    }
                ]}
                expandable={{
                    expandedRowRender: (record) =>
                        expandedRowKeys.includes(record.ActivityId) ? expandedRowRender(record) : null,
                    expandedRowKeys: expandedRowKeys,
                    onExpand: (expanded, record) => {
                        if (expanded) {
                            setExpandedRowKeys([record.ActivityId]); // Manually expand row
                        } else {
                            setExpandedRowKeys([]); // Collapse row when expanded is false
                        }
                    },
                    expandIcon: () => null, // Remove expand icon
                }}
                rowKey="ActivityId"
                scroll={{ x: 'max-content' }}
                dataSource={activity}
            />


                  </>}
        <div id="part-7"></div>
        <br/>
        <br/>
        <h3 className="text-2xL font-semibold"><u>อุปกรณ์</u></h3>
        <Form.Item label="โครงการของท่านมีอุปกรณ์ที่ใช้ร่วมในการวิจัยหรือไม่" layout='vertical'>
            <Switch checkedChildren="มี" unCheckedChildren="ไม่มี" onChange={handleShowItem} value={showItem} />
        </Form.Item>

       
        <Form form={item}>
        {showItem&&(<><Flex justify="space-between">
            <p className="font-semibold">อุปกรณ์ที่จำเป็นในงานวิจัย</p><Button onClick={()=>handleClickItem()}>เพิ่มข้อมูล</Button>
            </Flex>
              <Table 
              columns={[
                  {
                      title:'ข้อ',
                      dataIndex:'index',
                      width:120,
                      render: (text, record) => <>{record.index+1}</>, // Now rendering the index properly
                  },
                  {
                      title:'อุปกรณ์ที่จำเป็นต่อการวิจัย',
                      key: 'item',
                      dataIndex:'item',
                      render: (_, record, index) => (
                          <>
                          <Form.Item
                            name={[`needed_item`,index]}
                            initialValue={record.item}
                          >
                            <TextArea
                              value={record.item}
                              autoSize
                            />
                          </Form.Item>
                          </>
                      ),

                  },
                  {
                      dataIndex:'action',
                      key:'action',
                      width:150,
                      render:(_,record,index)=>(
                          <><Tooltip title="ลบข้อมูลในตาราง">
                          <Button
                            onClick={() =>handleNeededItemDel(index)}
                            danger
                          >
                            <DeleteOutlined />
                          </Button>
                        </Tooltip>
              
                          </>
                      )
                  }
              ]}
              dataSource={tmpItem}
              />
              
              
            <br/>
            <Flex justify="space-between">
                <p className="font-semibold">อุปกรณ์ที่มีอยู่แล้ว</p><Button onClick={()=>handleClickPossesesItem()}>เพิ่มข้อมูล</Button>
            </Flex>
                <Table 
                columns={[
                    {
                        title:'ข้อ',
                        dataIndex:'index',
                        width:120,
                        render: (text, record) => <>{record.index+1}</>,    
                    },
                    {
                        title:'อุปกรณ์ที่จำเป็นต่อการวิจัย',
                        dataIndex:'item',
                        key:'item',
                        render: (text, record,index) => (
                            <>
                            <Form.Item
                              name={[`posses_item`,index]}
                              initialValue={record.item}
                            >
                            <TextArea
                              value={record.item}
                              autoSize
                              />
                            </Form.Item>
                            </>
                        ),
                    },
                    {
                        dataIndex:'action',
                        key:'action',
                        width:150,
                        render:(_,record,index)=>(
                            <><Tooltip title="ลบข้อมูลในตาราง">
                                <Button 
                                    onClick={()=>{handlePosssesItemDel(index)
                                    }}
                                danger><DeleteOutlined /></Button></Tooltip>
                            </>
                        )
                    }
                ]}
                dataSource={possesTmpItem}
                />
            
        
            </>)}
            </Form>
            <br/>
            <Flex justify="center"><Button type="primary" 
                  style={{
                    backgroundColor: '#33b249',
                    color: 'white',
                    borderColor: '#33b249',
                  }}
                  onClick={submit}
                  >บันทึก</Button></Flex>
              <br/>
            <Flex justify="space-between" align="center" style={{ width: '100%' }}>
                  <div style={{ flex: 1, textAlign: 'left' }}>
                  <Button type="primary" onClick={()=>{setopen(true)}}>กลับไปหน้าก่อน</Button>
                  <Modal
                    width={'50vw'}
                    title='ยืนยันการกลับไปส่วนก่อน'
                    open={open}
                    onCancel={handleCancel}
                    footer={[
                      <><Button key="back" onClick={handleCancel}>
                        ยกเลิก
                      </Button>
                      <Button  key="go" danger type="primary" href={`/VRIIS/BudgetReqResearcher/${project_id}`}>
                        ตกลง
                      </Button>
                      </>
                    ]}
                    >
                    การตกลงจะนำทางท่านไปสู่ส่วนก่อนหน้านี้โดยไม่บันทึกข้อมูลที่ท่านกรอกไปแล้ว ท่านมั่นใจหรือไม่ที่จะกลับไปส่วนก่อน
                  </Modal>
                  </div>
                  <div style={{ flex: 1, textAlign: 'center' }}>
                  <Button type="primary" onClick={handleMainInfo}>บันทึกแล้วกลับหน้าดูข้อมูล</Button>
                  </div>
                  <div style={{ flex: 1, textAlign: 'right' }}>
                  <Button type="primary" style={{backgroundColor:'#33b249',color:'white',borderColor:'#33b249'}} onClick={handlenextpart}>บันทึกแล้วไปส่วนที่ 4</Button>
                  </div>
                </Flex>
            
                <br/>
            
            </div>
    )
}

